module.exports = __webpack_public_path__ + "img/account-inactive.28122f6d.svg";